import styled from "styled-components";

export const UserDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  overflow: scroll;
  max-height: calc(100vh - 300px);
`;

export const EmailSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

/**
 * Subtle panel for the invitation toggle — matches bordered card rhythm
 * without introducing a new visual language.
 */
export const InvitationPanel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  border-radius: 8px;
  border: 1px solid
    ${(props) => props.theme?.colors?.greySix || "rgba(0, 0, 0, 0.08)"};
  background: ${(props) =>
    props.theme?.colors?.greyOne || props.theme?.colors?.white || "#fafafa"};
`;

export const SendInvitationRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
`;

export const CheckboxColumn = styled.div`
  flex-shrink: 0;
  padding-top: 2px;
`;

export const SendInvitationCopy = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
`;

export const SelectCardContainer = styled.div`
  display: flex;
  gap: 16px;
  flex-direction: column;

  & > div > div > div > div > div:nth-child(2) {
    align-items: flex-start;
  }
`;

export const StepperContainer = styled.div`
  position: sticky;
  top: 0;
  z-index: 1;
  background: ${(props) => props.theme?.colors?.white || "#fff"};
  padding: 16px 0 8px;
`;

export const UserTypeSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

